import React, { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";
import { ModalContextProvider } from "core/context/modal.context";
import ModalStore from "core/stores/modal.store";

//https://css-tricks.com/replace-javascript-dialogs-html-dialog-element/
//PolyFill if needed: https://github.com/GoogleChrome/dialog-polyfill

type ModalDialogProps = {
    children: JSX.Element,
    store: ModalStore
}

const ModalDialog = observer((props: ModalDialogProps) => {
    const { store } = props;
    const { onClose, showClose = true, cssClassName = "" } = props.store;

    const dialog = useRef<HTMLDialogElement>(null);
    const [hasOpened, setHasOpened] = useState(false);

    const _close = () => dialog?.current?.close();

    const closeHandler = (e: any) => {
        if (e != null) {
            e.preventDefault();
        }

        store.updateDisplay(false);

        if (onClose != null) {
            onClose(e);
        }

        _close();
    };

    useEffect(() => {
        if (!store.display) {
            return;
        }

        if (dialog?.current) {
            dialog.current.removeAttribute("open");
            dialog.current.showModal();

            if (!hasOpened) {
                dialog.current.addEventListener("close", () => {
                    console.log("closing");
                    store.updateDisplay(false);
                })
                setHasOpened(true);
            }
        }

        setHasOpened(true);
    }, [store, store.display, hasOpened]);

    if (!store.display) {
        return null;
    }

    return (
        <dialog ref={dialog} className={`ui-modal-dialog ${cssClassName}`}>
            <section className="dialog-header">
                {showClose ? (<button type="button" className="close" onClick={closeHandler}>
                    <i className="icon-close close"></i>
                </button>) : null}
            </section>

            <ModalContextProvider dialog={dialog?.current}>
                {props?.children}
            </ModalContextProvider>
        </dialog>
    );
});

export default ModalDialog;
